import Model from './Model'
import RGBA from '../Fonts/RGBA'
import RoundedRect from '../Rendering/RoundedRect'
import FontDefinition from '../Fonts/FontDefinition'
import {gsap, TweenMax} from 'gsap';
import HoverMask from './HoverMask'
import State from './State'
import game from '../Game/GameInstance'
import colorSchemeRepository from '../Images/ColorSchemeRepository'

export default class TopBar extends Model
{

  constructor(width, height, game)
  {

    super(width, height);

    this.game = game;
    this.roundedRectRenderer = new RoundedRect();
    this.status = true;

    this.index = 0;
    this.hoverItem = null;
    this.hoverMask = new HoverMask(this, true);

    this.state = new State();


    this.circleSize = 0;

  }

  changeStatus(to) {

    this.isAnimating = true;
    this.index = to ? 1 : 0;



    // kill any running animations
    TweenMax.killTweensOf(this);

    // animate button from left to right or v.v.
    gsap.to(this,{ index : 1-this.index, duration: .15 } ).then(() => {
      this.index = to ? 0 : 1;
      this.needsRendering = true;
      this.isAnimating = false;
    });

  }

  doPosition(ctx) {

    ctx.clearRect(0,0, this.scale(this.width), this.scale(this.height));
    this.draw(ctx);

  }

  draw(ctx) {
    this.doDraw(ctx);
  }

  doDraw(ctx, force)
  {

    ctx.beginPath();
    ctx.rect(this.scale(-2),this.scale(-2), this.scale(this.width + 4), this.scale(this.height - 2));
    ctx.fillStyle = new RGBA(0,0,0, .6);
    ctx.strokeStyle = new RGBA(255, 255, 255, .2);
    ctx.strokeWidth = this.scale(1);
    ctx.fill();
    ctx.stroke();

    this.hoverMask.add('background', 0, 0, this.width, this.height).noCursor();

    // Disable top button
    // this.drawButton(ctx);
    this.drawTitle(ctx, this.game.title);
    this.drawCloseButton(ctx);


  }

  getButtonBox() {

    let box = {
      width: 75,
      height: 40,
      x : 100,
      y : 0
    };

    box.x = (this.width - box.width) / 2;
    box.y = (this.height - box.height) / 2;

    return box;

  }

  getCloseButtonBox()
  {

    let box = {
      width : 11,
      height : 11,
    };

    if (this.hoverItem === 'close') {
      box.width += 1;
      box.height += 1;
    }

    box.x = this.width - box.width - (this.height - box.height) / 2;
    box.y = (this.height - box.height) / 2;

    return box;

  }

  drawButton(ctx) {

    let box = this.getButtonBox();

    let radius = box.height / 2;


    ctx.fillStyle = colorSchemeRepository.get('toggleBackground');

    ctx.beginPath();

    // left circle
    ctx.arc(this.scale(box.x + radius), this.scale(box.y + radius), this.scale(radius), 0, Math.PI * 2);

    // right circle
    ctx.arc(this.scale(box.x + box.width - radius), this.scale(box.y + radius), this.scale(radius), 0, Math.PI * 2);

    // middle rect
    ctx.rect(this.scale(box.x + radius  ), this.scale(box.y), this.scale(box.width - radius * 2), this.scale(box.height));

    ctx.fill();

    ctx.beginPath();

    ctx.fillStyle = new RGBA(255);



    let path = new Path2D('M30.4999997,13.9999943 L30.6444601,14.0068609 C31.4051139,14.0795456 31.9999997,14.7202979 31.9999997,15.4999943 L31.9999997,15.4999943 L31.9999997,19.2499943 C31.9920069,25.1725943 27.6708519,30.2066468 21.8178519,31.1119943 L21.8178519,31.1119943 L21.7426533,31.1316657 C21.5991337,31.1856453 21.4999195,31.3238967 21.4998647,31.4825049 L21.4998647,31.4825049 L21.4998648,36.4999943 C21.4998648,37.3284193 20.8282923,37.9999943 19.9998648,37.9999943 C19.1714373,37.9999943 18.4998649,37.3284193 18.4998648,36.4999943 L18.4998648,36.4999943 L18.4998648,31.4824765 C18.4997943,31.2974335 18.3647583,31.140103 18.1818648,31.1119765 L18.1818648,31.1119765 L17.8805069,31.0614756 C12.1812067,30.0326336 8.00778285,25.0702985 7.99999974,19.2498565 L7.99999974,19.2498565 L7.99999974,15.4999943 C7.99999974,14.6715725 8.67157243,13.9999943 9.49999974,13.9999943 C10.3284274,13.9999943 10.9999997,14.6715725 10.9999997,15.4999943 L10.9999997,15.4999943 L10.9999997,19.25 C10.9999997,24.220565 15.0294349,28.25 19.9999997,28.25 C24.9705649,28.25 28.9999997,24.220565 28.9999997,19.25 L28.9999997,19.25 L28.9999997,15.4999943 L28.9999997,15.4999943 L29.0068663,15.3555352 C29.079551,14.5948871 29.7203035,13.9999943 30.4999997,13.9999943 L30.4999997,13.9999943 Z M20.0000004,2 C23.7279204,2 26.7500002,5.02208 26.7500002,8.75 L26.7500002,8.75 L26.7500002,19.25 C26.7458604,22.97621 23.7262104,25.9958664 20.0000004,26 L20.0000004,26 C16.2736702,25.9958028 13.2540688,22.9760928 13.2500002,19.2498828 L13.2500002,19.2498828 L13.2500002,8.75 C13.2500002,5.02208 16.2720804,2 20.0000004,2 Z');

    let svgSize = 40;
    let svgOutputSize = 20;
    let iconScale = svgOutputSize / svgSize; // display size / svg source size


    // drop the mic
    ctx.save();
    ctx.fillStyle = new RGBA(255);
    ctx.translate(this.scale(box.x + box.width - svgOutputSize - radius / 2), this.scale(box.y + (box.height - svgOutputSize) / 2));
    ctx.scale(this.zoom * iconScale, this.zoom * iconScale);
    ctx.fill(path, 'evenodd');
    ctx.restore();


    // drop the people
    path = new Path2D('M7.91385009,9.851142 L8.1219188,9.85527535 C9.92113335,9.93014177 11.6046442,11.0159325 12.35612,12.78338 C13.396625,15.23063 12.256235,18.057995 9.80900001,19.0985 L9.80900001,19.0985 L9.74227152,19.1358974 C9.6389732,19.2083823 9.57691428,19.329025 9.581,19.4585 L9.581,19.4585 L9.59164747,19.5340618 C9.62181,19.6562562 9.71217375,19.7572124 9.8345,19.799 L9.8345,19.799 L10.0642157,19.8827665 C12.3361334,20.7643853 13.8471908,22.9539439 13.8500019,25.4075181 L13.8500019,25.4075181 L13.8500019,29.852752 L13.8500019,29.852752 L13.8432511,29.9538484 C13.7942837,30.3147984 13.4848799,30.593002 13.1105004,30.5930013 L13.1105004,30.5930013 L11.7875004,30.5930013 C11.5946199,30.5931483 11.4341181,30.7412538 11.4185004,30.9335013 L11.4185004,30.9335013 L10.8845004,37.3220012 C10.8525324,37.7050727 10.5324039,38.000002 10.1480004,38.000002 L10.1480004,38.000002 L5.70350043,38.000002 C5.31852093,38.0005547 4.99751628,37.7056472 4.96550043,37.3220012 L4.96550043,37.3220012 L4.43300044,30.9335014 C4.41664294,30.7410192 4.25567644,30.5930866 4.06250044,30.5930014 L4.06250044,30.5930014 L2.74100045,30.5930014 L2.74100045,30.5930014 L2.64045103,30.586237 C2.27876806,30.5371706 2.00000045,30.2271413 2.00000045,29.8520014 L2.00000045,29.8520014 L2.00000045,25.4075013 C2.00382545,22.8724263 3.61686545,20.6194698 6.01550045,19.7990013 L6.01550045,19.7990013 L6.08753421,19.7656839 C6.15526206,19.7251513 6.20910467,19.6638717 6.24036651,19.58993 C6.32101851,19.3991705 6.23175801,19.1791506 6.04100001,19.0985 L6.04100001,19.0985 L5.8148488,18.9953807 C4.77454345,18.4882139 3.94888981,17.6215484 3.49388001,16.55138 C2.45337501,14.10413 3.59376501,11.276765 6.04100001,10.23626 C6.65281251,9.97613372 7.2883822,9.85231341 7.91385009,9.851142 Z M32.0638516,9.85114203 L32.2719203,9.85527538 C34.0711349,9.9301418 35.7546457,11.0159325 36.5061215,12.78338 C37.5466265,15.23063 36.4062365,18.057995 33.9590015,19.0985 L33.9590015,19.0985 L33.8895796,19.1369664 C33.8249774,19.1823157 33.7757329,19.2473474 33.74993,19.3233665 C33.6833615,19.519484 33.7883825,19.7324326 33.9845,19.799 L33.9845,19.799 L34.2141639,19.8828406 C36.4855452,20.7651234 37.9963108,22.9542236 38.000003,25.407522 L38.000003,25.407522 L38.000003,29.8519992 C38.000003,30.2612382 37.6682524,30.5929932 37.2590134,30.5929992 L37.2590134,30.5929992 L35.9375134,30.5929992 C35.7443374,30.5930847 35.5833709,30.7410162 35.5670134,30.9334992 L35.5670134,30.9334992 L35.0345135,37.3219991 C35.0024975,37.7056451 34.681493,38.0005518 34.2965135,37.9999998 L34.2965135,37.9999998 L29.8520135,37.9999998 C29.46761,37.9999998 29.1474819,37.7050706 29.1155135,37.3219991 L29.1155135,37.3219991 L28.5815135,30.9334993 C28.5658955,30.7412525 28.405394,30.5931468 28.2125135,30.5929993 L28.2125135,30.5929993 L26.8887627,30.5929989 L26.8887627,30.5929989 L26.7876799,30.5860451 C26.4268284,30.5363517 26.1492477,30.2263908 26.1499999,29.8520113 L26.1499999,29.8520113 L26.1499999,25.4075 C26.1531515,22.87268 27.7656815,20.619596 30.1640015,19.799 L30.1640015,19.799 L30.2361489,19.7658313 C30.3040017,19.7254307 30.358001,19.6642318 30.3894215,19.5903125 C30.4704395,19.3997105 30.3816035,19.1795183 30.1910015,19.0985 L30.1910015,19.0985 L29.9648503,18.9953808 C28.924545,18.4882139 28.0988913,17.6215484 27.6438815,16.55138 C26.6033765,14.10413 27.7437665,11.276765 30.1910015,10.23626 C30.802814,9.97613375 31.4383837,9.85231344 32.0638516,9.85114203 Z M20.048211,1.99702981 L20.2454446,2.00415732 C21.688064,2.09142452 23.0388044,2.94534399 23.6937802,4.34671993 C24.6464752,6.38508493 23.7663652,8.80980793 21.7280002,9.76249993 L21.7280002,9.76249993 L21.6633865,9.80047608 C21.6032103,9.8445263 21.5571014,9.9059711 21.5318615,9.97736 C21.4631015,10.171841 21.565019,10.38524 21.7595,10.454 L21.7595,10.454 L21.9770175,10.5381941 C23.9093535,11.3362524 25.1826816,13.2232957 25.1854976,15.3291366 L25.1854976,15.3291366 L25.1854976,17.5550003 C25.1854976,17.9642438 24.8537409,18.2960003 24.4444974,18.2960003 L24.4444974,18.2960003 L23.2174974,18.2960003 C23.0287869,18.2955473 22.8698891,18.4370063 22.8484974,18.6245003 L22.8484974,18.6245003 L22.2169974,24.3050002 C22.1756979,24.6797797 21.8590449,24.9635002 21.4819974,24.9635002 L21.4819974,24.9635002 L18.5179975,24.9635002 C18.140638,24.9635002 17.8235111,24.6800137 17.7814975,24.3050002 L17.7814975,24.3050002 L17.1514975,18.6245002 C17.1314785,18.4369012 16.9726585,18.2949351 16.7839975,18.2960002 L16.7839975,18.2960002 L15.5554975,18.2960002 L15.5554975,18.2960002 L15.4554672,18.288176 C15.0957129,18.235775 14.8189523,17.9282767 14.8145005,17.5549972 L14.8145005,17.5549972 L14.8145005,15.3304998 C14.8186405,13.1448498 16.1904955,11.1955923 18.2465005,10.4539998 L18.2465005,10.4539998 L18.3142983,10.4220552 C18.3782299,10.3836582 18.4297342,10.3266599 18.4613602,10.2578614 C18.5475172,10.0704379 18.4654237,9.84865678 18.2780002,9.76249993 L18.2780002,9.76249993 L18.0652362,9.65537543 C17.2985795,9.24085011 16.6830178,8.59007293 16.3122202,7.79671993 C15.3595252,5.75835493 16.2396352,3.33363193 18.2780002,2.38093993 C18.8512903,2.11299446 19.455142,1.99002673 20.048211,1.99702981 Z');
    ctx.save();
    ctx.fillStyle = new RGBA(255);
    ctx.translate(this.scale(box.x + radius / 2), this.scale(box.y + (box.height - svgOutputSize) / 2));
    ctx.scale(this.zoom * iconScale, this.zoom * iconScale);
    ctx.fill(path, 'evenodd');
    ctx.restore();

    // inner circle and icon

    let w = (box.width - radius * 2) * this.index;
    ctx.arc(this.scale(box.x + radius + w), this.scale(box.y + radius), this.scale(radius - 2.5), 0, Math.PI * 2);

    ctx.fill();


    this.hoverMask.add('button-switch', box.x, box.y, box.width, box.height)
      .click(() => {
        this.game.switchView();
      });


  }

  drawTitle(ctx, text) {

    let fontSize = 22;

    ctx.font = (new FontDefinition('Montserrat')).size(this.scale(fontSize)).weight(700);

    let box = {
      x : 20,
      y : 20,
      width: ctx.measureText(text).width,
      height: fontSize
    };

    ctx.strokeStyle = new RGBA(255);
    ctx.fillStyle = new RGBA(255);

    ctx.fillText(text, this.scale(box.x), this.scale(box.y + box.height));

  }

  drawCloseButton(ctx) {

    let box = this.getCloseButtonBox();

    ctx.beginPath();
    ctx.lineCap = "round";
    ctx.moveTo(this.scale(box.x + box.width), this.scale(box.y));
    ctx.lineTo(this.scale(box.x), this.scale(box.y + box.height));
    ctx.moveTo(this.scale(box.x), this.scale(box.y));
    ctx.lineTo(this.scale(box.x + box.width), this.scale(box.y + box.height));
    ctx.strokeStyle = new RGBA(255);
    ctx.lineWidth = this.scale(2.5);
    ctx.stroke();

    if (this.circleSize) {
      ctx.beginPath();
      let start = Math.PI * 1.5 + this.circleSize / 2;
      ctx.arc(this.scale(box.x + box.width / 2), this.scale(box.y + box.height / 2), this.scale(box.width * 1.2), start, this.circleSize + start);
      ctx.stroke();
    }


    this.hoverMask.add('button-close', box.x - 5, box.y - 5, box.width + 10, box.height + 10)
      .over(() => {
        gsap.to(this, { circleSize : Math.PI * 2}).then(() => { this.isAnimating = false; });
        this.isAnimating = true;
      })
      .out(() => {
        gsap.to(this, { circleSize : 0}).then(() => { this.isAnimating = false; });;
        this.isAnimating = true;
      })
      .click(() => {
        window.dispatchEvent(new Event('close-interactive-map'))
      });





  }
  //
  // hover(x,y) {
  //
  //   let buttonBox = this.getButtonBox();
  //   let closeButtonBox = this.getCloseButtonBox();
  //
  //   if (x > buttonBox.x && x < buttonBox.x + buttonBox.width) {
  //     if (y > buttonBox.y && y < buttonBox.y + buttonBox.height) {
  //       return this.setHoverItem('button');
  //     }
  //   }
  //
  //   let padding = 10;
  //   if (x > closeButtonBox.x - padding && x < closeButtonBox.x + closeButtonBox.width + padding * 2) {
  //     if (y > closeButtonBox.y - padding  && y < closeButtonBox.y + closeButtonBox.height + padding * 2) {
  //       return this.setHoverItem('close');
  //     }
  //   }
  //
  //   return this.setHoverItem(null);
  //
  // }
  //
  // click(x, y) {
  //
  //   if (this.hoverItem === 'button') {
  //     this.game.switchView();
  //   }
  //   if (this.hoverItem === 'close') {
  //     alert('Nee, je mag niet weg.');
  //   }
  //
  // }

  // setHoverItem(status) {
  //   if (this.hoverItem !== status) {
  //     this.hoverItem = status;
  //     this.needsRendering = true;
  //   }
  //   return (this.hoverItem !== null);
  // }
}
